import { MarkovStartvector } from "server/models"

export interface MarkovStartvectorProps {
    startvectorId: number
}

export type MarkovStartvectorValidation = { [key in keyof MarkovStartvector]?: string}

export interface MarkovStartvectorState {
    startvectors: MarkovStartvector[]
    startvectorSelected: MarkovStartvector
    startvectorEdit: MarkovStartvector

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_STARTVECTORS = "MARKOV_STARTVECTORS"
export const MARKOV_STARTVECTOR_SELECTED = "MARKOV_STARTVECTOR_SELECTED"
export const MARKOV_STARTVECTOR_EDIT = "MARKOV_STARTVECTOR_EDIT"

export const MARKOV_STARTVECTOR_RELOAD_LIST = "MARKOV_STARTVECTOR_RELOAD_LIST"
export const MARKOV_STARTVECTOR_RELOAD_EDIT = "MARKOV_STARTVECTOR_RELOAD_EDIT"
